import * as THREE from "three";
import Time from "./time";
import Input from "./input";
import AssetLoader from "./assetLoader";

class Canvas {
  render() {
    requestAnimationFrame(this.render);
    if (this.renderFrame) {
      this.renderer.render(this.scene, this.camera);
      this.renderFrame = false;
    }
  }

  onResize() {
    this.width = this.parent.clientWidth;
    this.height = this.parent.clientHeight;

    this.renderer.setSize(this.width, this.height);

    if (this.camera) {
      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();
    }
    this.renderFrame = true;
  }

  loadScene(scene, onLoadCallback) {
    this.sceneInit = scene.init;
    this.sceneUpdate = scene.update;
    this.sceneData = scene.data;
    this.loader.removeAllListeners();
    this.loader.on("load", assets => this.onLoad(assets));
    this.loader.on("load", onLoadCallback);
    this.loader.load(scene.assets, scene.data);
  }

  init(renderer, parent) {
    this.renderer = renderer;
    this.parent = parent;

    this.width = parent.clientWidth;
    this.height = parent.clientHeight;

    this.input = new Input(this.parent);
    this.time = new Time();
    this.raycaster = new THREE.Raycaster();
    this.render = this.render.bind(this);
    this.renderFrame = true;

    const pixelRatio = Math.min(2, window.devicePixelRatio || 1);

    renderer.setSize(this.width, this.height);
    renderer.setClearColor("#000000");
    renderer.shadowMap.enabled = true;
    renderer.autoClear = false;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.4;
    renderer.setPixelRatio(pixelRatio);

    this.loader = new AssetLoader(renderer);

    this.resizeHandler = this.onResize.bind(this);
    window.addEventListener("resize", this.resizeHandler, false);
  }

  onLoad(assets) {
    this.time.removeAllListeners();
    this.input.removeAllListeners();

    this.sceneInit(this, this.sceneData, assets);

    this.time.on("tick", dt => this.sceneUpdate(dt, this));
    this.renderFrame = true;
    this.render();
  }

  onDestroy() {
    if (this) {
      if (this.resizehandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
      this.time.removeAllListeners();
      this.input.removeAllListeners();
    }
  }
}

export default Canvas;
